import { Controller } from "@hotwired/stimulus";

// Records a result-card click without delaying the navigation it rides on:
// sendBeacon queues the POST and the browser delivers it after unload. The
// CSRF token travels in the body because a beacon carries no custom headers.
export default class extends Controller {
  static values = { url: String, churchId: Number, rank: Number };

  record() {
    const body = new FormData();
    body.append(
      "authenticity_token",
      document.querySelector('meta[name="csrf-token"]')?.content ?? "",
    );
    body.append("church_id", this.churchIdValue);
    body.append("rank", this.rankValue);
    body.append("elapsed_ms", Math.round(performance.now()));
    navigator.sendBeacon(this.urlValue, body);
  }
}
